
import { iDocument, iParType, iDateFormat, iOutputParam } from '@/modules/documentExecution/documentDetails/DocumentDetails'
import { createValidations, ICustomValidatorMap } from '@/helpers/commons/validationHelper'
import { defineComponent, PropType } from 'vue'
import mainDescriptor from '@/modules/documentExecution/documentDetails/DocumentDetailsDescriptor.json'
import driversDescriptor from '@/modules/documentExecution/documentDetails/tabs/drivers/DocumentDetailsDriversDescriptor.json'
import outputParamDescriptor from './DocumentDetailsOutputParametersDescriptor.json'
import useValidate from '@vuelidate/core'
import KnListBox from '@/components/UI/KnListBox/KnListBox.vue'
import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'
import Dropdown from 'primevue/dropdown'
import InlineMessage from 'primevue/inlinemessage'

export default defineComponent({
    name: 'document-drivers',
    components: { KnListBox, Dropdown, KnValidationMessages, InlineMessage },
    props: { selectedDocument: { type: Object as PropType<iDocument>, required: true }, typeList: { type: Array as PropType<iParType[]>, required: true }, dateFormats: { type: Array as PropType<iDateFormat[]>, required: true } },
    emits: ['driversChanged'],
    data() {
        return {
            v$: useValidate() as any,
            mainDescriptor,
            driversDescriptor,
            outputParamDescriptor,
            selectedParam: {} as iOutputParam,
            document: {} as any
        }
    },
    created() {
        this.document = this.selectedDocument
    },
    validations() {
        const outputParamsValidator = (value) => {
            return Object.keys(this.selectedParam).length === 0 || value
        }
        const customValidators: ICustomValidatorMap = { 'output-params-validator': outputParamsValidator }
        const validationObject = { selectedParam: createValidations('selectedParam', outputParamDescriptor.validations.selectedParam, customValidators) }
        return validationObject
    },
    methods: {
        addParam() {
            this.selectedParam = { numberOfErrors: 1, biObjectId: this.document.id, formatCode: null, formatValue: null, isUserDefined: true, type: this.typeList[0] ? this.typeList[0] : ({} as iParType), tempId: this.document.outputParameters.length + 1 } as iOutputParam
            this.document.outputParameters.push(this.selectedParam)
        },
        selectParam(event) {
            this.selectedParam = event
        },
        markSelectedParamForChange() {
            this.selectedParam.isChanged = true
            this.selectedParam.numberOfErrors = this.v$.$errors.length
        },

        deleteParamConfirm(event) {
            this.$confirm.require({
                header: this.$t('common.toast.deleteConfirmTitle'),
                message: this.$t('common.toast.deleteMessage'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => this.deleteParam(event.item)
            })
        },
        async deleteParam(paramToDelete) {
            if (paramToDelete.id) {
                await this.$http
                    .delete(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/documentdetails/${this.selectedDocument.id}/outputparameters/${paramToDelete.id}`, { headers: { 'X-Disable-Errors': 'true' } })
                    .then(() => {
                        let deletedParam = this.document.outputParameters.findIndex((param) => param.id === paramToDelete.id)
                        this.document.outputParameters.splice(deletedParam, 1)
                        this.$store.commit('setInfo', { title: this.$t('common.toast.deleteTitle'), msg: this.$t('common.toast.deleteSuccess') })
                        this.selectedParam = {} as iOutputParam
                    })
                    .catch((error) => {
                        this.$store.commit('setError', { title: this.$t('common.toast.errorTitle'), msg: error.message })
                    })
            } else {
                let deletedParam = this.document.outputParameters.findIndex((param) => param.tempId === paramToDelete.tempId)
                this.document.outputParameters.splice(deletedParam, 1)
                this.selectedParam = {} as iOutputParam
            }
        }
    }
})
